import { render, staticRenderFns } from "./GalleryFolderDlg.vue?vue&type=template&id=6c579341"
import script from "./GalleryFolderDlg.ts?vue&type=script&lang=ts&external"
export * from "./GalleryFolderDlg.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports